// extracted by mini-css-extract-plugin
export var wrapper = "newsletter-module--wrapper--3nvTI";
export var bg = "newsletter-module--bg--2E9t7";
export var section = "newsletter-module--section--1F4kM";
export var info = "newsletter-module--info--3ijk6";